import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import CourseSchedulerIndex from "./CourseSchedulerIndex";
import { getPreBaseRoute } from "../../../../components";
export const getCourseSchedulerBasePath = () => "/app/courseScheduler";
const CourseSchedulerRoutes = () => (_jsx(Switch, { children: _jsx(Route, { path: getPreBaseRoute() + getCourseSchedulerBasePath(), component: CourseSchedulerIndex }) }));
export default CourseSchedulerRoutes;
